import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { AllConstructorType } from '../schema';

export function useAllConstructors() {
  const [{ page = 1, ...searchArg }] = useQueryParams({
    page: NumberParam,
    search: StringParam,
    dominant: StringParam,
    startDate: StringParam,
    finishDate: StringParam
  });

  const initial: AllConstructorType = {
    data: [],
    totalPages: 0,
    currentPage: 1,
    totalElements: 0
  };

  const { data = initial, ...arg } = useQuery<Pagination<AllConstructorType['data'][number]>>(
    ['all-constructors', page, searchArg],
    async () => {
      const res = await $api.post('/v1/excel-constructor/custom-template/filter', { page, size: 15, ...searchArg });

      const data: Pagination<AllConstructorType['data'][number]> = res?.data?.data;

      return {
        ...data,
        data: data?.data?.map(item => ({
          ...item,
          updatedDate: timeStampToDate({
            date: item?.updatedDate,
            timeStamp: item?.updatedTimestamp
          })
        }))
      };
    }
  );

  return { ...data, ...arg };
}
